import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import clsx from "clsx";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import http from '../services/httpService';
import { useHistory } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

// import { otpPath } from '../utils/varialbles';
// import Otp from "./otp";

const useStyles = makeStyles((theme) => ({
    root: {
        height: "100vh",
    },
    textField: {
        margin: "10px auto",
    },
    submit: {
        borderRadius: "31px",
        height: "40px",
        lineHeight: "40px",
        // background: '#09316A',
        width: 150
    },
}));
let recoverPassword = false;
function ResetPassword(props) {
    localStorage.clear();

    const classes = useStyles();
    const history = useHistory();
    const [showotp, setShowOtp] = useState(false);
    const [profileDetails, setProfileDetails] = useState({});
    const [showRecoverPassword, setShowRecoverPassword] = useState(false)
    const [values, setValues] = React.useState({
        new: "",
        confirm: "",
        showPassword: false,
    });

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const handleSubmit = (event) => {
        recoverPassword = true
        // event.preventDefault();
        // event.stopImmediatePropagation();
        let postObject = {
            email: props.email,
            password: values["new"],
            confirm: values["confirm"]
            ,
        };

        http
            .post("changepassword", postObject)
            .then(function (response) {
                response = response.data;
                if (
                    response &&
                    response.statusCode === 0

                ) {
                    toast.success(response.data);
                    //   login={updateLoginPage}

                    props.login()

                    // updateLoginPage()
                    // requestForToken(response.Employee_ID)

                } else {
                    toast.error(response.data);
                    // alert(response.data)
                }
            })
            .catch(function (error) { });
    };

    const goToOtp = () => {
        setShowOtp(true);
    };
    const updateShowPassword = () => {
        setShowRecoverPassword(!showRecoverPassword)
    }
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            // this.setState({value:e.target.value})
            handleSubmit()
        }
    }

    return (
        <div>
            <div>
                {/* <div className="getworking">Get Working!</div> */}
                <div>

                    <>
                        <p
                            className="login_tag"
                            style={{
                                textAlign: 'left',
                                // width: '68%',
                                // fontSize: '47px',
                                color: '#393939',
                                marginBottom: 0
                            }}
                        >
                            Reset password
                        </p>

                        <>
                            <FormControl
                                fullWidth
                                className={clsx(classes.margin, classes.textField)}
                            >
                                <InputLabel htmlFor="email"
                                    style={{ color: "#A7A7A7" }}
                                >
                                    Enter new password
                                </InputLabel>

                                <Input
                                    id="standard-adornment-password"
                                    variant="outlined"
                                    margin="none"
                                    required
                                    onKeyPress={handleKeyPress}
                                    fullWidth
                                    type={values.showPassword ? "text" : "password"}
                                    value={values.new}
                                    onChange={handleChange("new")}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {values.showPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>

                                        </InputAdornment>
                                    }
                                />

                            </FormControl>
                            <FormControl
                                fullWidth
                                className={clsx(classes.margin, classes.textField)}
                            >
                                <InputLabel htmlFor="standard-adornment-password"
                                    style={{ color: "#A7A7A7" }}

                                >
                                    Confirm password
                                </InputLabel>
                                <Input
                                    id="email"
                                    variant="outlined"
                                    margin="none"
                                    required
                                    fullWidth
                                    type="text"
                                    value={values.confirm}
                                    onChange={handleChange("confirm")}
                                />
                            </FormControl>
                            {/* <Button color='primary' style={{float:'right',cursor:'pointer'}} onClick={goToOtp}>Forgot Password</Button> */}
                            {/* {showotp ? <Otp /> : null} */}
                            <div
                                className="login_text"
                            >
                                <div item xs={6} sm={6}
                                    style={{ color: "#0066FF", cursor: "pointer" }}
                                >
                                    {/* <span
                                        onClick={updateShowPassword}
                    >
                    Forgot Password?
                      </span> */}
                                </div>
                                <div item xs={6} sm={6}>
                                    <Button
                                        type="button" // Need to change type to submit later
                                        fullWidth
                                        variant="contained"

                                        color="primary"
                                        className={classes.submit}
                                        onClick={handleSubmit}
                                    >
                                        Login
                                    </Button>
                                </div>
                            </div>

                        </>
                    </>

                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
